import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CourseSectionDetailsSideMenuComponent } from './course-section-details-side-menu/course-section-details-side-menu.component';

@Component({
  selector: 'app-course-section-details',
  imports: [
    TranslateModule,
    RouterOutlet,
    CourseSectionDetailsSideMenuComponent,
  ],
  templateUrl: './course-section-details.component.html',
  styleUrl: './course-section-details.component.scss',
})
export class CourseSectionDetailsComponent {
  constructor() {}
}
